var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"copy-wrap",class:{ showBorder: _vm.showBorder },attrs:{"title":"Click to Copy"},on:{"click":_vm.copyClipboard}},[_c('Copy-Icon',{attrs:{"width":"16","height":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }